Namespace 'Common.Dashboard.Charts'

class Common.Dashboard.Charts.BarMenuView extends Backbone.View
  template: JST['backbone/templates/common/dashboard/charts/bar_menu']
  className: 'bar-menu-dropdown dropdown d-inline'

  initialize: ({
    exportable = false,
    resizable = false,
    isMaximized = false,
    customOptionViews = []
  }) =>
    @exportableOptionsView = new Common.Dashboard.Charts.ExportableOptionsView() if exportable
    @resizableOptionsView = new Common.Dashboard.Charts.ResizableOptionsView(isMaximized: isMaximized) if resizable
    @customOptionViews = customOptionViews

  render: =>
    @$el.html @template
    @_renderExportableOptions() if @exportableOptionsView
    @_renderResizableOptions() if @resizableOptionsView
    @_renderCustomOptions()
    @

  _renderExportableOptions: =>
    @$el.find('.dropdown-menu').append(@exportableOptionsView.render().el)
    @listenTo(@exportableOptionsView, 'chart:exportPNG', @_exportPNG)
    @listenTo(@exportableOptionsView, 'chart:exportCSV', @_exportCSV)
    @listenTo(@exportableOptionsView, 'chart:exportXLSX', @_exportXLSX)

  _renderResizableOptions: =>
    @$el.find('.dropdown-menu').append(@resizableOptionsView.render().el)
    @listenTo(@resizableOptionsView, 'chart:toggleMaximize', @_toggleMaximizeView)

  _exportPNG: =>
    @chart.exportChart() if @chart

  _exportCSV: =>
    @chart.downloadCSV() if @chart

  _exportXLSX: =>
    @chart.downloadXLSX() if @chart

  _toggleMaximizeView: =>
    return unless @chartView
    @chartView.toggleMaximize()
    @resizableOptionsView.updateTitle(@chartView.widget.get('is_maximized'))

  _renderCustomOptions: ->
    @customOptionViews.forEach (optionView) => @$('.dropdown-menu').prepend optionView.render().el
